module.exports = __webpack_public_path__ + "static/media/parentBC_self_logo.04ee2e81.svg";